// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout--main--WgLsy","header":"Layout--header--2RVAo","carouselPostGrid":"Layout--carouselPostGrid--2Ic43"};